export default __webpack_public_path__ + "static/media/nigeria.a39bc19c.svg";